export * from 'catalogs/constants/catalogs_constants';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/constants/index.js